export const enum Speed {
  Walk = .08,
  Run = .12
}
